import {useDispatch, useSelector} from 'react-redux'
import {Formik} from 'formik'
import Input from '../../components/core/input'
import {SimpleBlueButton} from '../../components/core/button'
import {teamSchema} from '../../utils/validation'
import {addService} from '../../stores/resources'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import TextHelper from '../../utils/text'
import RenderedForPaid from '../../components/pages/RenderedForPaid'
import limitUsageManager from '../../utils/hooks/limitUsageManager'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const AddPopup = ({closeModal}) => {
    const text = useNamespaceTranslations('services')
    const usageLimits = useNamespaceTranslations('usage-limits')
    const showLoader = useSelector(state => state.resources.showLoader)
    const dispatch = useDispatch()
    const currentTeamId = useSelector(state => state.teams.selectedTeamId)
    const organisationLimitUsages = useSelector(state => state.auth.organisationLimitUsages)
    const {value: serviceLimit, usage: serviceUsage, remainingUsageValue} = limitUsageManager(usageLimits.limit_modules.monitoring.module, usageLimits.limit_keys.service_count.limit_key, organisationLimitUsages)
    const initialFormValues = {
        name: '',
        team_id: ''
    }

    const addNewService = (values, {setFieldError}) => {
        let formData = {
            name: values.name,
            team_id: currentTeamId
        }
        dispatch(addService(formData, setFieldError, closeModal))
    }

    const getLimitIsExceeded = () => {
        return serviceUsage >= serviceLimit
    }

    const getPaidText = () => {
        return remainingUsageValue > 0 && TextHelper.replaceAllChars(
            TextHelper.replaceAllChars(
                text.for_paid_text, ':remaining', remainingUsageValue
            ),
            ':limit',
            serviceLimit
        )
    }

    return (
        <div className="modal-body">
            <RenderedForPaid
                forPaidText={getPaidText() || text.for_paid_general}
                isExceeded={getLimitIsExceeded()}
                isTextWithLimits={!!getPaidText()}/>
            <Formik
                enableReinitialize={true}
                initialValues={initialFormValues}
                onSubmit={addNewService}
                validationSchema={teamSchema}
                validateOnBlur={false}
                validateOnChange={false}>
                {({values, errors, handleSubmit, setFieldValue, handleChange}) => (
                    <form onSubmit={handleSubmit} className="modal-body">
                        <Input
                            type="text"
                            value={values.name}
                            infoText={text.service_name_info}
                            placeholder={text.service_name}
                            name="name"
                            error={errors.name}
                            onChange={e => {
                                handleChange(e)
                                setFieldValue('name', e.target.value)
                            }}
                            inputIsDisabled={getLimitIsExceeded()}
                        />
                        <SimpleBlueButton
                            type="submit"
                            disabled={getLimitIsExceeded()}>
                            {showLoader && <ButtonLoader/>}
                            <span>{text.submit}</span>
                        </SimpleBlueButton>
                    </form>
                )}
            </Formik>
        </div>
    )
}

export default AddPopup
